export default "<div class=\"k-card-header\" ng-class=\"$ctrl.class\" ng-transclude></div>"